// extracted by mini-css-extract-plugin
export var box = "_5h-1";
export var checked = "_5h-2";
export var descriptionSpacer = "_5h-9";
export var disabled = "_5h-3";
export var icon = "_5h-6";
export var input = "_5h-0";
export var labelSpacer = "_5h-8";
export var medium = "_5h-5";
export var small = "_5h-4";
export var text = "_5h-7";